import React, { useState, useEffect } from 'react'
import { Panel, SelectPicker, Input, Row, Col, Table, Icon, ButtonGroup, IconButton } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import moment from 'moment'
import { DD_MM_YYYY_SLASH, REQUEST_DATE_FORMAT } from '../../constants/date'
import { sessionRemoveItem, sessionSetItemStr } from '../../utils/sessionHelpers'
import { getColorItemRequestStatus } from '../assetBookingManagementWidgets/BookingStatusUtils'
import TagCell from '../../components/cell/TagCell'

export default function AssetRequestManagementTable({
  schema,
  searchForm,
  loading,
  onReload = () => {},
  onSelect = () => {},
  onSearch = () => {},
  lengthMenu,
  disableAdd,
  onPreview = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const [tableData, setTableData] = useState([])
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [projectCode, setProjectCode] = useState()
  const [projectName, setProjectName] = useState()
  const [requestForUseDocNo, setRequestForUseDocNo] = useState()
  const [requestForUseStatus, setRequestForUseStatus] = useState()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()

  const fs = localStorage.getItem('fontSize')
  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  useEffect(() => {
    setTableData(schema.values)
  }, [schema.values])

  const handleSearch = async () => {
    let request = {
      requestForUseDocNo: requestForUseDocNo || null,
      projectCode: projectCode || null,
      projectName: projectName || null,
      startDate: startDate ? moment(startDate).format(REQUEST_DATE_FORMAT) : null,
      endDate: endDate ? moment(endDate).format(REQUEST_DATE_FORMAT) : null,
      requestForUseStatus: requestForUseStatus || null,
    }
    onSearch(request, 1, displayLength)
  }

  const handleCancel = async () => {
    // console.log('handleCancel')
    setProjectCode('')
    setProjectName('')
    setRequestForUseDocNo('')
    setRequestForUseStatus('')
    setStartDate('')
    setEndDate('')
    setDisplayLength(5)
    onSearch({}, 1, 5)
  }

  const handleChangePage = (dataKey) => {
    console.log('handleChangePage page', dataKey)

    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(
        displayLength,
        dataKey,
        requestForUseDocNo || null,
        projectCode || null,
        projectName || null,
        startDate ? moment(startDate).format(REQUEST_DATE_FORMAT) : null,
        endDate ? moment(endDate).format(REQUEST_DATE_FORMAT) : null,
        requestForUseStatus || null
      )
    }
  }

  const handleChangeLength = (dataKey) => {
    console.log('handleChangeLength dataKey', typeof onReload === 'function', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(
        dataKey,
        1,
        requestForUseDocNo || null,
        projectCode || null,
        projectName || null,
        startDate ? moment(startDate).format(REQUEST_DATE_FORMAT) : null,
        endDate ? moment(endDate).format(REQUEST_DATE_FORMAT) : null,
        requestForUseStatus || null
      )
    }
  }

  return (
    <>
      {!disableAdd && (
        <>
          <Panel header={`${searchForm?.header || 'ค้นหา'}`} bordered collapsible defaultExpanded>
            <Row style={{ marginTop: -10 }}>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {searchForm.projectCode.label}
                <Input
                  placeholder={searchForm.projectCode.hint || searchForm.projectCode.label}
                  value={projectCode}
                  onChange={(value) => {
                    setProjectCode(value)
                  }}
                />
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {searchForm.projectName.label}
                <Input
                  placeholder={searchForm.projectName.hint || searchForm.projectName.label}
                  value={projectName}
                  onChange={(value) => {
                    setProjectName(value)
                  }}
                />
              </Col>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
            </Row>

            <Row style={{ marginTop: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24}></Col>

              <Col lg={8} md={8} sm={24} xs={24}>
                {searchForm.requestForUseDocNo.label}
                <Input
                  placeholder={
                    searchForm.requestForUseDocNo.hint || searchForm.requestForUseDocNo.label
                  }
                  value={requestForUseDocNo}
                  onChange={(value) => {
                    setRequestForUseDocNo(value)
                  }}
                />
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {searchForm.requestForUseStatus.label}
                <SelectPicker
                  searchable={false}
                  data={searchForm.requestForUseStatus.options}
                  value={requestForUseStatus}
                  block
                  placeholder={`เลือก${searchForm.requestForUseStatus.label || ''}`}
                  onChange={(value) => {
                    setRequestForUseStatus(value)
                  }}
                />
              </Col>

              <Col lg={4} md={4} sm={24} xs={24}></Col>
            </Row>

            <Row style={{ marginTop: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24}></Col>

              <Col lg={8} md={8} sm={24} xs={24}>
                {searchForm.startDate.label}
                <DatePickerCustom
                  {...props}
                  placement="auto"
                  value={startDate}
                  disabledDate={(date) => endDate && moment(endDate).isBefore(date, new Date())}
                  onChange={(value) => {
                    setStartDate(value)
                  }}
                />
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {searchForm.endDate.label}
                <DatePickerCustom
                  {...props}
                  placement="auto"
                  value={endDate}
                  disabledDate={(date) => startDate && moment(startDate).isAfter(date, new Date())}
                  onChange={(value) => {
                    setEndDate(value)
                  }}
                />
              </Col>

              <Col lg={4} md={4} sm={24} xs={24}></Col>
            </Row>

            <Row style={{ marginTop: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24}></Col>

              <Col lg={8} md={8} sm={24} xs={24}>
                {/* <div style={{ marginTop: 30 }}> */}
                <SearchButton
                  disabled={loading}
                  onClick={handleSearch}
                  style={{ marginTop: 0, marginLeft: 0 }}
                >
                  ค้นหา
                </SearchButton>
                <CancelButton onClick={handleCancel} style={{ marginTop: 0, marginLeft: 10 }}>
                  ยกเลิก
                </CancelButton>
                {/* </div> */}
              </Col>

              <Col lg={4} md={4} sm={24} xs={24}></Col>
            </Row>
          </Panel>

          <Row style={{ marginTop: 20 }}>
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <SaveButton
                icon="plus-square"
                disabled={false}
                onClick={() => {
                  sessionRemoveItem('isViewOnly')
                  onSelect(null)
                }}
                style={{
                  marginRight: 10,
                }}
              >
                สร้างคำขอใช้
              </SaveButton>
            </Col>
          </Row>
        </>
      )}

      <Table
        wordWrap
        minHeight={400}
        autoHeight
        loading={loading}
        headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
        data={tableData || []}
        style={{ marginTop: '10px' }}
      >
        <Column width={100} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return (page - 1) * displayLength + index + 1
            }}
          </Cell>
        </Column>

        <Column width={140}>
          <HeaderCell>เลขที่คำขอใช้</HeaderCell>
          <Cell dataKey="requestForUseDocNo" />
        </Column>

        <Column width={140}>
          <HeaderCell>วันที่ขอใช้</HeaderCell>
          <Cell dataKey="requestForUseDate" />
        </Column>

        <Column minWidth={200} flexGrow={1}>
          <HeaderCell>ใช้กับโครงการ</HeaderCell>
          <Cell>
            {(rowData) => {
              return `${rowData.projectCode || ''} ${rowData.projectName || ''}`
            }}
          </Cell>
        </Column>

        <Column width={160} align="center">
          <HeaderCell>จำนวนครุภัณฑ์</HeaderCell>
          <Cell dataKey="assetCount" />
        </Column>

        <Column width={200} align="center">
          <HeaderCell>สถานะการขอใช้</HeaderCell>
          <Cell>
            {(rowData) => {
              const item = getColorItemRequestStatus(rowData.requestForUseStatus)

              return (
                <TagCell
                  dataKey="requestForUseStatusName"
                  rowData={rowData}
                  bgColor={item.bgColor}
                  color={item.fontColor}
                />
              )
            }}
          </Cell>
        </Column>

        <Column width={160}>
          <HeaderCell>ผู้ขอใช้</HeaderCell>
          <Cell dataKey="requester" />
        </Column>

        <Column width={130} align="center" fixed="right">
          <HeaderCell>จัดการรายการ</HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <>
                  <ButtonGroup>
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-df"
                      size="sm"
                      icon={<Icon icon="eye" className="bt-gost-icon-none-radius" />}
                      onClick={(e) => {
                        onSelect(rowData)
                        sessionSetItemStr('isViewOnly', 'isViewOnly')
                      }}
                    ></IconButton>
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-edit"
                      size="sm"
                      icon={<Icon icon="edit" className="bt-gost-icon-none-radius-edit" />}
                      disabled={rowData.requestForUseStatus == 4}
                      onClick={(e) => {
                        onSelect(rowData)
                        sessionRemoveItem('isViewOnly')
                      }}
                    ></IconButton>
                    {!disableAdd && (
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-info"
                        disabled={rowData.requestForUseStatus == 4}
                        size="sm"
                        icon={<Icon icon="print" className="bt-gost-icon-none-radius-info" />}
                        onClick={() => onPreview(rowData)}
                      ></IconButton>
                    )}
                  </ButtonGroup>
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>

      <TablePagination
        lengthMenu={lengthMenu || defaultLengthMenu}
        activePage={page || defaultPage}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total || 0} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={schema.totalSize}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />
    </>
  )
}
